export default "__VITE_ASSET__b25f00a0__"